import { render, staticRenderFns } from "./NotAuthorized.vue?vue&type=template&id=22b365a3&"
import script from "./NotAuthorized.vue?vue&type=script&lang=js&"
export * from "./NotAuthorized.vue?vue&type=script&lang=js&"
import style0 from "./NotAuthorized.vue?vue&type=style&index=0&id=22b365a3&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22b365a3')) {
      api.createRecord('22b365a3', component.options)
    } else {
      api.reload('22b365a3', component.options)
    }
    module.hot.accept("./NotAuthorized.vue?vue&type=template&id=22b365a3&", function () {
      api.rerender('22b365a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/miscellaneous/NotAuthorized.vue"
export default component.exports